<!--
    校区管理-账户管理-充值
    功能：账号套餐充值
    说明：旧版
-->
<template>
  <div class="pay">
    <div class="title">选择套餐购买</div>
    <div class="list">
      <div class="box" v-for="(item, index) in comboList" :key="index">
        <input type="radio" hidden v-model="num" :id="`item${item.id}`" name="radio" :value="item.id">
        <label :for="`item${item.id}`" @click="checkNum(item.id)">
          <div class="img">
            <img :src="item.image2 ? item.image2 : ''" :onerror="errorImg" alt="">
          </div>
          <div class="bottom">
            价格：<span>￥<b>{{ item.price | formatter }}</b></span>
          </div>
        </label>
      </div>
    </div>
    <el-dialog
      title="购买套餐"
      :visible.sync="dialogVisible"
      width="648px"
      :before-close="closeDialog"
      class="pay_dialog">
      <div class="main">
        <div class="success" v-if="paySuccess">
          <h1>
            <i class="icon"></i>
            购买成功！
          </h1>
          <p>购买套餐：{{ changeItem.name }}</p>
          <p>实付金额：<span>{{ changeItem.price | formatter }}</span>元</p>
        </div>
        <div class="top clearfix" v-else>
          <div class="left">
            <h1>购买套餐：</h1>
            <p>{{ changeItem.name }}</p>
            <h1>应付金额确认：</h1>
            <p><span>{{ changeItem.price | formatter }}</span>元</p>
          </div>
          <div class="right">
            <el-button @click="getCover" type="primary">去支付</el-button>
            <!--<div class="qrcode">
              <img class="qrcode" :src="changeItem.cover" alt="">
            </div>
            <p>（可使用微信、支付宝扫码支付）</p>-->
          </div>
        </div>
        <div class="bottom" v-if="(changeItem.description && changeItem.description !== '') || (changeItem.image && changeItem.image !=='')">
          <h1>套餐说明：</h1>
          <p v-if="changeItem.description && changeItem.description !== ''">{{ changeItem.description }}</p>
          <img v-if="changeItem.image && changeItem.image !==''" :src="changeItem.image" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import baseUrl from "../../utils/api";
  import setting from '../../utils/setting';
  import defaultImg from '../../assets/images/pay_default_img.png';

  export default {
    name: "AccountPay",
    data() {
      return {
        errorImg: `this.src="${defaultImg}"`,
        comboList: [],
        num: '',
        cashNum: '',
        dialogVisible: false,
        changeItem: {},
        successTime: null,
        paySuccess: false
      }
    },
    filters: {
      formatter(val) {
        return setting.toDecimal(val, 2)
      }
    },
    computed: {
      school() {
        return this.$store.state.choicesSchool
      }
    },
    created() {
      this.$http.get(`${baseUrl}/api/bill/prepaid-card-type?page=1&per_page=999`)
        .then((res) => {
          this.comboList = res.items.map(item => {
            return {...item, cover: null, order_no: null}
          });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    mounted() {
      // 10分钟后重置二维码
      setTimeout(() => {
        this.comboList.forEach(item => {
          item.cover = null
          item.order_no = null
        });
        this.dialogVisible = false;
        if (this.successTime) {
          clearInterval(this.successTime);
        }
        this.successTime = null;
      },600000)
    },
    methods: {
      checkNum(id) {
        this.comboList.forEach(item => {
          if (item.id === id) {
            this.cashNum = item.price;
            this.dialogVisible = true;
            this.paySuccess = false;
            this.changeItem = item;
            if (this.changeItem.order_no) {
              this.checkPaySuccee();
            }
            if (!item.cover) {
              this.load(id, item.price)
            }
          }
        })
      },
      load(id, price) {
        const data = {
          amount: price,
          wallet_type: "cash",
          hook_buy_prepaid_card: id
        };
        this.$http.post(`${baseUrl}/api/expense/main/${this.school.main_id}/recharge-unified-trade-native`, data)
          .then((res) => {
            this.comboList.forEach(item => {
              if (item.id === id) {
                item.cover = res.data.code_img_url;
                item.order_no = res.data.out_trade_no;
                this.checkPaySuccee();
              }
            })
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      },
      checkPaySuccee() {
        this.successTime = setInterval(() => {
          this.$http.get(`${baseUrl}/api/expense/main/${this.school.main_id}/recharge-query/${this.changeItem.order_no}`)
            .then((res) => {
              if (res.data.trade_status === 'success') {
                this.paySuccess = true;
                clearInterval(this.successTime);
                this.successTime = null;
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }, 5000)
      },
      closeDialog(done) {
        clearInterval(this.successTime);
        this.successTime = null;
        done();
      },
      getCover () {
        window.open(this.changeItem.cover);
      }
    }
  }
</script>

<style lang="scss" scoped>
.pay {
  .title {
    font-size: 18px;
    color: #333;
  }
  .list {
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    .box {
      width: 200px;
      height: 224px;
      margin-right: 28px;
      border-radius: 10px;
      box-shadow: 0 4px 13px 0 rgba(90, 90, 90, 0.17);
      margin-bottom: 28px;
      overflow: hidden;
      label {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 10px;
        box-sizing: border-box;
        img {
          display: block;
          width: 200px;
          height: 178px;
          &[src=""], &:not([src]){
            opacity:0;
          }
        }
        .bottom {
          width: 100%;
          height: 46px;
          line-height: 46px;
          font-size: 14px;
          color: rgba(51, 51, 51, 0.5);;
          box-sizing: border-box;
          padding-left: 13px;
          span {
            color: #EB412B;
            b {
              font-size: 20px;
              font-weight: normal;
            }
          }
        }
        &:hover {
          &:before {
            display: block;
            content: "";
            width: 100%;
            height: 100%;
            border-radius: 10px;
            box-sizing: border-box;
            border: 4px solid #1E8EFF;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
      input:checked + label {
        &:after {
          display: block;
          content: "";
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background: url("../../assets/images/icon_pay_checked.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }
  .pay_dialog {
    /deep/
    .el-dialog__header {
      padding: 17px 20px;
      border-bottom: 1px solid #E9E9E9;
    }
    .main {
      .top {
        .left {
          float: left;
          h1 {
            font-size: 14px;
            color: rgba(51,51,51,0.5);
            font-weight: normal;
            margin: 0;
          }
          p {
            font-size: 16px;
            color: #333;
            margin-top: 10px;
            margin-bottom: 30px;
            span {
              font-size: 24px;
              color: #EB412B;
            }
          }
        }
        .right {
          float: right;
          /*width: 180px;*/
          .qrcode {
            width: 154px;
            margin: 0 auto;
            img {
              display: block;
              border: 1px solid #e3e3e3;
              width: 100%;
              height: auto;
            }
          }
          p {
            font-size: 12px;
            color: rgba(51,51,51,0.5);
          }
        }
      }
      .bottom {
        h1 {
          font-size: 14px;
          color: rgba(51,51,51,0.5);
          font-weight: normal;
          margin: 0 0 20px 0;
        }
        p {
          font-size: 14px;
          color: #333;
          line-height: 24px;
          margin: 0;
        }
        img {
          display: block;
          max-width: 100%;
        }
      }
      .success {
        text-align: center;
        width: 200px;
        margin: 0 auto;
        h1 {
          font-size: 20px;
          color: #333;
          font-weight: normal;
          margin-bottom: 30px;
          .icon {
            width: 30px;
            height: 30px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
            background: url("../../assets/images/icon_success.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        p {
          text-align: left;
          font-size: 14px;
          color: #333;
          margin-bottom: 13px;
          span {
            font-size: 18px;
            color: #EB412B;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Account/Pay.vue